import React from 'react';
import { formatISO2DisplayDateString } from 'utils/dateFunctions';
import i18n from 'i18n';
import {
  cpfFormat,
  formatName,
  formatPhoneNumber,
  translateGender,
} from 'utils/AuxiliarFunctions';
import { LoadingHU } from 'components/LoadingHU';
import { useProfileContext } from './Context/ProfileContext';
import './ProfilePage.css';

export default function ProfilePage() {
  const { profileState, loading } = useProfileContext();

  return (
    <div className="profilePage">
      <link
        rel="stylesheet"
        href="https://cdn.es.gov.br/fonts/font-awesome/css/font-awesome.min.css"
      />

      {loading ? (
        <LoadingHU state />
      ) : (
        <div className="profilePage-content">
          <div className="profilePage-title">
            <h1 className="pageTitle">Perfil</h1>
          </div>
          <div className="profilePage-grid">
            <div>
              <b>Nome Completo</b>
              <p>{formatName(profileState.name)}</p>
            </div>

            <div>
              <b>Data de Nascimento</b>
              <p>
                {formatISO2DisplayDateString(
                  profileState.dataNascimento,
                  i18n.language,
                )}
              </p>
            </div>

            <div>
              <b />
              <p />
            </div>

            <div>
              <b>CNS</b>
              <p>{profileState.cns}</p>
            </div>

            <div>
              <b>CPF</b>
              <p>{cpfFormat(profileState.cpf)}</p>
            </div>

            <div>
              <b>Sexo</b>
              <p>{translateGender(profileState.genero)}</p>
            </div>

            <div>
              <b>Telefone</b>
              <p>{formatPhoneNumber(profileState.telefone)}</p>
            </div>

            <div>
              <b>Email</b>
              <p>{profileState.email}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
